function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
function _callSuper(t, o, e) {
  return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e));
}
function _possibleConstructorReturn(t, e) {
  if (e && ("object" == _typeof(e) || "function" == typeof e)) return e;
  if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
  return _assertThisInitialized(t);
}
function _assertThisInitialized(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function _isNativeReflectConstruct() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
  } catch (t) {}
  return (_isNativeReflectConstruct = function _isNativeReflectConstruct() {
    return !!t;
  })();
}
function _getPrototypeOf(t) {
  return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) {
    return t.__proto__ || Object.getPrototypeOf(t);
  }, _getPrototypeOf(t);
}
function _inherits(t, e) {
  if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, {
    constructor: {
      value: t,
      writable: !0,
      configurable: !0
    }
  }), Object.defineProperty(t, "prototype", {
    writable: !1
  }), e && _setPrototypeOf(t, e);
}
function _setPrototypeOf(t, e) {
  return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) {
    return t.__proto__ = e, t;
  }, _setPrototypeOf(t, e);
}
function _regeneratorRuntime() {
  "use strict";

  var r = _regenerator(),
    e = r.m(_regeneratorRuntime),
    t = (Object.getPrototypeOf ? Object.getPrototypeOf(e) : e.__proto__).constructor;
  function n(r) {
    var e = "function" == typeof r && r.constructor;
    return !!e && (e === t || "GeneratorFunction" === (e.displayName || e.name));
  }
  var o = {
    throw: 1,
    return: 2,
    break: 3,
    continue: 3
  };
  function a(r) {
    var e, t;
    return function (n) {
      e || (e = {
        stop: function stop() {
          return t(n.a, 2);
        },
        catch: function _catch() {
          return n.v;
        },
        abrupt: function abrupt(r, e) {
          return t(n.a, o[r], e);
        },
        delegateYield: function delegateYield(r, o, a) {
          return e.resultName = o, t(n.d, _regeneratorValues(r), a);
        },
        finish: function finish(r) {
          return t(n.f, r);
        }
      }, t = function t(r, _t, o) {
        n.p = e.prev, n.n = e.next;
        try {
          return r(_t, o);
        } finally {
          e.next = n.n;
        }
      }), e.resultName && (e[e.resultName] = n.v, e.resultName = void 0), e.sent = n.v, e.next = n.n;
      try {
        return r.call(this, e);
      } finally {
        n.p = e.prev, n.n = e.next;
      }
    };
  }
  return (_regeneratorRuntime = function _regeneratorRuntime() {
    return {
      wrap: function wrap(e, t, n, o) {
        return r.w(a(e), t, n, o && o.reverse());
      },
      isGeneratorFunction: n,
      mark: r.m,
      awrap: function awrap(r, e) {
        return new _OverloadYield(r, e);
      },
      AsyncIterator: _regeneratorAsyncIterator,
      async: function async(r, e, t, o, u) {
        return (n(e) ? _regeneratorAsyncGen : _regeneratorAsync)(a(r), e, t, o, u);
      },
      keys: _regeneratorKeys,
      values: _regeneratorValues
    };
  })();
}
function _regeneratorValues(e) {
  if (null != e) {
    var t = e["function" == typeof Symbol && Symbol.iterator || "@@iterator"],
      r = 0;
    if (t) return t.call(e);
    if ("function" == typeof e.next) return e;
    if (!isNaN(e.length)) return {
      next: function next() {
        return e && r >= e.length && (e = void 0), {
          value: e && e[r++],
          done: !e
        };
      }
    };
  }
  throw new TypeError(_typeof(e) + " is not iterable");
}
function _regeneratorKeys(e) {
  var n = Object(e),
    r = [];
  for (var t in n) r.unshift(t);
  return function e() {
    for (; r.length;) if ((t = r.pop()) in n) return e.value = t, e.done = !1, e;
    return e.done = !0, e;
  };
}
function _regeneratorAsync(n, e, r, t, o) {
  var a = _regeneratorAsyncGen(n, e, r, t, o);
  return a.next().then(function (n) {
    return n.done ? n.value : a.next();
  });
}
function _regeneratorAsyncGen(r, e, t, o, n) {
  return new _regeneratorAsyncIterator(_regenerator().w(r, e, t, o), n || Promise);
}
function _regeneratorAsyncIterator(t, e) {
  function n(r, o, i, f) {
    try {
      var c = t[r](o),
        u = c.value;
      return u instanceof _OverloadYield ? e.resolve(u.v).then(function (t) {
        n("next", t, i, f);
      }, function (t) {
        n("throw", t, i, f);
      }) : e.resolve(u).then(function (t) {
        c.value = t, i(c);
      }, function (t) {
        return n("throw", t, i, f);
      });
    } catch (t) {
      f(t);
    }
  }
  var r;
  this.next || (_regeneratorDefine2(_regeneratorAsyncIterator.prototype), _regeneratorDefine2(_regeneratorAsyncIterator.prototype, "function" == typeof Symbol && Symbol.asyncIterator || "@asyncIterator", function () {
    return this;
  })), _regeneratorDefine2(this, "_invoke", function (t, o, i) {
    function f() {
      return new e(function (e, r) {
        n(t, i, e, r);
      });
    }
    return r = r ? r.then(f, f) : f();
  }, !0);
}
function _regenerator() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */var e,
    t,
    r = "function" == typeof Symbol ? Symbol : {},
    n = r.iterator || "@@iterator",
    o = r.toStringTag || "@@toStringTag";
  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
      u = Object.create(c.prototype);
    return _regeneratorDefine2(u, "_invoke", function (r, n, o) {
      var i,
        c,
        u,
        f = 0,
        p = o || [],
        y = !1,
        G = {
          p: 0,
          n: 0,
          v: e,
          a: d,
          f: d.bind(e, 4),
          d: function d(t, r) {
            return i = t, c = 0, u = e, G.n = r, a;
          }
        };
      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
            i = p[t],
            d = G.p,
            l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }
        if (o || r > 1) return a;
        throw y = !0, n;
      }
      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");
        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }
        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }
  var a = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () {
      return this;
    }), t),
    u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);
  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () {
    return this;
  }), _regeneratorDefine2(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator = function _regenerator() {
    return {
      w: i,
      m: f
    };
  })();
}
function _regeneratorDefine2(e, r, n, t) {
  var i = Object.defineProperty;
  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }
  _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) {
    if (r) i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n;else {
      var o = function o(r, n) {
        _regeneratorDefine2(e, r, function (e) {
          return this._invoke(r, n, e);
        });
      };
      o("next", 0), o("throw", 1), o("return", 2);
    }
  }, _regeneratorDefine2(e, r, n, t);
}
function _OverloadYield(e, d) {
  this.v = e, this.k = d;
}
var _marked = /*#__PURE__*/_regeneratorRuntime().mark(p);
function _createForOfIteratorHelper(r, e) {
  var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (!t) {
    if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
      t && (r = t);
      var _n = 0,
        F = function F() {};
      return {
        s: F,
        n: function n() {
          return _n >= r.length ? {
            done: !0
          } : {
            done: !1,
            value: r[_n++]
          };
        },
        e: function e(r) {
          throw r;
        },
        f: F
      };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  var o,
    a = !0,
    u = !1;
  return {
    s: function s() {
      t = t.call(r);
    },
    n: function n() {
      var r = t.next();
      return a = r.done, r;
    },
    e: function e(r) {
      u = !0, o = r;
    },
    f: function f() {
      try {
        a || null == t.return || t.return();
      } finally {
        if (u) throw o;
      }
    }
  };
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
import { Plugin as m, Command as E } from "../../../../../@ckeditor_ckeditor5-core@45.1.0/node_modules/@ckeditor/ckeditor5-core/dist/index.js";
import { Observer as b, BubblingEventInfo as v, DomEventData as k } from "../../../../../@ckeditor_ckeditor5-engine@45.1.0/node_modules/@ckeditor/ckeditor5-engine/dist/index.js";
import { env as S } from "../../../../../@ckeditor_ckeditor5-utils@45.1.0/node_modules/@ckeditor/ckeditor5-utils/dist/index.js"; /**
                                                                                                                                 * @license Copyright (c) 2003-2025, CKSource Holding sp. z o.o. All rights reserved.
                                                                                                                                 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
                                                                                                                                 */ /**
                                                                                                                                    * @license Copyright (c) 2003-2025, CKSource Holding sp. z o.o. All rights reserved.
                                                                                                                                    * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
                                                                                                                                    */
function p(s, e) {
  var _iterator, _step, t;
  return _regeneratorRuntime().wrap(function p$(_context) {
    while (1) switch (_context.prev = _context.next) {
      case 0:
        _iterator = _createForOfIteratorHelper(e);
        _context.prev = 1;
        _iterator.s();
      case 3:
        if ((_step = _iterator.n()).done) {
          _context.next = 11;
          break;
        }
        t = _step.value;
        _context.t0 = t && s.getAttributeProperties(t[0]).copyOnEnter;
        if (!_context.t0) {
          _context.next = 9;
          break;
        }
        _context.next = 9;
        return t;
      case 9:
        _context.next = 3;
        break;
      case 11:
        _context.next = 16;
        break;
      case 13:
        _context.prev = 13;
        _context.t1 = _context["catch"](1);
        _iterator.e(_context.t1);
      case 16:
        _context.prev = 16;
        _iterator.f();
        return _context.finish(16);
      case 19:
      case "end":
        return _context.stop();
    }
  }, _marked, null, [[1, 13, 16, 19]]);
}
var y = /*#__PURE__*/function (_E) {
  function y() {
    _classCallCheck(this, y);
    return _callSuper(this, y, arguments);
  }
  _inherits(y, _E);
  return _createClass(y, [{
    key: "execute",
    value: function execute() {
      var _this = this;
      this.editor.model.change(function (e) {
        _this.enterBlock(e), _this.fire("afterExecute", {
          writer: e
        });
      });
    }
  }, {
    key: "enterBlock",
    value: function enterBlock(e) {
      var t = this.editor.model,
        n = t.document.selection,
        i = t.schema,
        o = n.isCollapsed,
        r = n.getFirstRange(),
        a = r.start.parent,
        c = r.end.parent;
      if (i.isLimit(a) || i.isLimit(c)) return !o && a == c && t.deleteContent(n), !1;
      if (o) {
        var l = p(e.model.schema, n.getAttributes());
        return f(e, r.start), e.setSelectionAttribute(l), !0;
      } else {
        var _l = !(r.start.isAtStart && r.end.isAtEnd),
          g = a == c;
        if (t.deleteContent(n, {
          leaveUnmerged: _l
        }), _l) {
          if (g) return f(e, n.focus), !0;
          e.setSelection(c, 0);
        }
      }
      return !1;
    }
  }]);
}(E);
function f(s, e) {
  s.split(e), s.setSelection(e.parent.nextSibling, 0);
}
var C = {
  insertParagraph: {
    isSoft: !1
  },
  insertLineBreak: {
    isSoft: !0
  }
};
var h = /*#__PURE__*/function (_b) {
  function h(e) {
    var _this2;
    _classCallCheck(this, h);
    _this2 = _callSuper(this, h, [e]);
    var t = _this2.document;
    var n = !1;
    t.on("keydown", function (i, o) {
      n = o.shiftKey;
    }), t.on("beforeinput", function (i, o) {
      if (!_this2.isEnabled) return;
      var r = o.inputType;
      S.isSafari && n && r == "insertParagraph" && (r = "insertLineBreak");
      var a = o.domEvent,
        c = C[r];
      if (!c) return;
      var l = new v(t, "enter", o.targetRanges[0]);
      t.fire(l, new k(e, a, {
        isSoft: c.isSoft
      })), l.stop.called && i.stop();
    });
    return _this2;
  }
  _inherits(h, _b);
  return _createClass(h, [{
    key: "observe",
    value: function observe() {}
  }, {
    key: "stopObserving",
    value: function stopObserving() {}
  }]);
}(b);
var I = /*#__PURE__*/function (_m) {
  function I() {
    _classCallCheck(this, I);
    return _callSuper(this, I, arguments);
  }
  _inherits(I, _m);
  return _createClass(I, [{
    key: "init",
    value: function init() {
      var e = this.editor,
        t = e.editing.view,
        n = t.document,
        i = this.editor.t;
      t.addObserver(h), e.commands.add("enter", new y(e)), this.listenTo(n, "enter", function (o, r) {
        n.isComposing || r.preventDefault(), !r.isSoft && (e.execute("enter"), t.scrollToTheSelection());
      }, {
        priority: "low"
      }), e.accessibility.addKeystrokeInfos({
        keystrokes: [{
          label: i("Insert a hard break (a new paragraph)"),
          keystroke: "Enter"
        }]
      });
    }
  }], [{
    key: "pluginName",
    get: function get() {
      return "Enter";
    }
  }, {
    key: "isOfficialPlugin",
    get: function get() {
      return !0;
    }
  }]);
}(m);
var T = /*#__PURE__*/function (_E2) {
  function T() {
    _classCallCheck(this, T);
    return _callSuper(this, T, arguments);
  }
  _inherits(T, _E2);
  return _createClass(T, [{
    key: "execute",
    value: function execute() {
      var _this3 = this;
      var e = this.editor.model,
        t = e.document;
      e.change(function (n) {
        A(e, n, t.selection), _this3.fire("afterExecute", {
          writer: n
        });
      });
    }
  }, {
    key: "refresh",
    value: function refresh() {
      var e = this.editor.model,
        t = e.document;
      this.isEnabled = x(e.schema, t.selection);
    }
  }]);
}(E);
function x(s, e) {
  if (e.rangeCount > 1) return !1;
  var t = e.anchor;
  if (!t || !s.checkChild(t, "softBreak")) return !1;
  var n = e.getFirstRange(),
    i = n.start.parent,
    o = n.end.parent;
  return !((d(i, s) || d(o, s)) && i !== o);
}
function A(s, e, t) {
  var n = t.isCollapsed,
    i = t.getFirstRange(),
    o = i.start.parent,
    r = i.end.parent,
    a = o == r;
  if (n) {
    var c = p(s.schema, t.getAttributes());
    u(s, e, i.end), e.removeSelectionAttribute(t.getAttributeKeys()), e.setSelectionAttribute(c);
  } else {
    var _c = !(i.start.isAtStart && i.end.isAtEnd);
    s.deleteContent(t, {
      leaveUnmerged: _c
    }), a ? u(s, e, t.focus) : _c && e.setSelection(r, 0);
  }
}
function u(s, e, t) {
  var n = e.createElement("softBreak");
  s.insertContent(n, t), e.setSelection(n, "after");
}
function d(s, e) {
  return s.is("rootElement") ? !1 : e.isLimit(s) || d(s.parent, e);
}
var L = /*#__PURE__*/function (_m2) {
  function L() {
    _classCallCheck(this, L);
    return _callSuper(this, L, arguments);
  }
  _inherits(L, _m2);
  return _createClass(L, [{
    key: "init",
    value: function init() {
      var e = this.editor,
        t = e.model.schema,
        n = e.conversion,
        i = e.editing.view,
        o = i.document,
        r = this.editor.t;
      t.register("softBreak", {
        allowWhere: "$text",
        isInline: !0
      }), n.for("upcast").elementToElement({
        model: "softBreak",
        view: "br"
      }), n.for("downcast").elementToElement({
        model: "softBreak",
        view: function view(a, _ref) {
          var c = _ref.writer;
          return c.createEmptyElement("br");
        }
      }), i.addObserver(h), e.commands.add("shiftEnter", new T(e)), this.listenTo(o, "enter", function (a, c) {
        o.isComposing || c.preventDefault(), c.isSoft && (e.execute("shiftEnter"), i.scrollToTheSelection());
      }, {
        priority: "low"
      }), e.accessibility.addKeystrokeInfos({
        keystrokes: [{
          label: r("Insert a soft break (a <code>&lt;br&gt;</code> element)"),
          keystroke: "Shift+Enter"
        }]
      });
    }
  }], [{
    key: "pluginName",
    get: function get() {
      return "ShiftEnter";
    }
  }, {
    key: "isOfficialPlugin",
    get: function get() {
      return !0;
    }
  }]);
}(m);
export { I as Enter, L as ShiftEnter };